import { ReactElement } from "react";
import { LoadingIndicator } from "../../../Common/UI/components/Loading";

export const GridLoadingOverlay = (): ReactElement => {
  return <LoadingIndicator show children={undefined}></LoadingIndicator>;
};
